import type { FormType } from '@ra-mr/types';

export async function submitFormSubmission(data: {
  formType: FormType;
  data: Record<string, unknown>;
  email: string;
  _honeypot?: string;
  _formLoadedAt?: number;
}): Promise<{ success: boolean }> {
  const res = await fetch('/api/public/form-submissions', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });

  if (!res.ok) {
    throw new Error('Failed to submit form');
  }

  return res.json();
}
